var _g, _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect2, _path11, _path12, _path13, _rect3, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect4, _path22, _rect5, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTraders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#edf9fc",
    vectorEffect: "non-scaling-stroke",
    d: "m113.1 52.27 23.27-.01q.63 0 .63-.63v-7.88a1 1 0 0 1 1-1h6.92q.78 0 .29-.61l-19.23-23.51a1.32 1.31-44.6 0 0-2.02-.01l-19.38 23.05a.88.87-72 0 0 .73 1.44l6.48-.47a.89.89 0 0 1 .96.89v8.39q0 .35.35.35"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8da1ba",
    vectorEffect: "non-scaling-stroke",
    d: "M164.06 67.74c-3.62.98-8.27 2.26-9.49 6.14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fac1bf",
    vectorEffect: "non-scaling-stroke",
    d: "M154.57 73.88c-4.36 3.81-1.09 8.7-4.49 13.55q-.31.43.14.71l1.55.96a.94.94 0 0 1 .44.72c.31 3.55 2.08 8.42 6.76 6.49q.51-.21.78.28.55 1 .19 2.78"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cfeef6",
    vectorEffect: "non-scaling-stroke",
    d: "M159.94 99.37c-4.8 2.57-11.83 4.27-14.31 9.23q-2.29 4.58-4.04 8.96"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff80ab",
    vectorEffect: "non-scaling-stroke",
    d: "m141.59 117.56-.13-.82a1.15 1.15 0 0 0-1.79-.77l-14.28 9.84a1.25 1.24-36.9 0 1-1.66-.23l-16.66-19.9a4.63 4.61 81.3 0 0-1.72-1.27l-13.64-5.73"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fac1bf",
    vectorEffect: "non-scaling-stroke",
    d: "M91.71 98.68q-1.04-1.79-.12-3.98.19-.46.69-.5c7.2-.64 5.32-10.3 5.08-16.23"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8da1ba",
    vectorEffect: "non-scaling-stroke",
    d: "M97.36 77.97q2.55-6.46-3.33-8.29c-1.99-.62-12.58-3.23-15.59-.99-9.29 6.9-3.63 14.07 1.64 20.77"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fac1bf",
    vectorEffect: "non-scaling-stroke",
    d: "m80.08 89.46-.85 4.96"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dff4f9",
    vectorEffect: "non-scaling-stroke",
    d: "m79.23 94.42-14.45.06q-.65.01-.5-.62c2.92-12.85-16.41-15.5-15.43.03a.54.54 0 0 1-.52.57l-2.55.05"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#edf9fc",
    vectorEffect: "non-scaling-stroke",
    d: "m45.78 94.51-14.93.44a1.61 1.61 0 0 0-1.56 1.63q.19 10.84.79 21.93c.16 3.04 1.02 5.95 1.68 8.93q.02.09.09.02l.19-.23q.15-.18.18.05l.09.75"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c1e7ff",
    vectorEffect: "non-scaling-stroke",
    d: "m32.31 128.03.34 11.03"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#edf9fc",
    vectorEffect: "non-scaling-stroke",
    d: "M32.65 139.06q-1.09 1.05-.55 3.22.12.45.58.52c1.62.24 2.93 3.85 3.42 5.71a.75.74 85.5 0 0 .65.56q10.76.88 20.55.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dff4f9",
    vectorEffect: "non-scaling-stroke",
    d: "M57.3 149.37q3.91.49 6.61-.51"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff80ab",
    vectorEffect: "non-scaling-stroke",
    d: "m63.91 148.86 3.81 3.64q.35.34.35.82l-.08 28.58"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c1e7ff",
    vectorEffect: "non-scaling-stroke",
    d: "M67.99 181.9c-.55 12.17.23 24.58-1.5 36.57q-3.03 21.02-3.89 42.28-.01.47.42.63l2.28.89"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fac1bf",
    vectorEffect: "non-scaling-stroke",
    d: "m65.3 262.27-1.1 5.85"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#96aed4",
    vectorEffect: "non-scaling-stroke",
    d: "m64.2 268.12-5.51 9.84"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8da1ba",
    vectorEffect: "non-scaling-stroke",
    d: "M58.69 277.96c-1.3 2.34-1.33 4.09 1.86 4.08q5.47-.03 10.83-.05.57 0 .58-.57l.02-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#96aed4",
    vectorEffect: "non-scaling-stroke",
    d: "m71.98 278.16-.01-8.98"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fac1bf",
    vectorEffect: "non-scaling-stroke",
    d: "m71.97 269.18.82-6.75"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c1e7ff",
    vectorEffect: "non-scaling-stroke",
    d: "M72.79 262.43q1.56.08 2.51-.43.43-.23.49-.72 3.46-28.13 9.84-55.73a.59.59 0 0 1 1.17.11c.22 7.84-1.51 15.18-2.3 22.93-1.07 10.45-.57 21.57-.32 32.15a.63.63 0 0 0 .55.6l3.36.44"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fac1bf",
    vectorEffect: "non-scaling-stroke",
    d: "m88.09 261.78-.47 8.67"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#96aed4",
    vectorEffect: "non-scaling-stroke",
    d: "m87.62 270.45-2.25 7.78"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8da1ba",
    vectorEffect: "non-scaling-stroke",
    d: "M85.37 278.23q-.58 1.67-.33 2.71a.72.72 0 0 0 .7.56h32.12q.6 0 .87-.53 1.06-2.08-1.25-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#96aed4",
    vectorEffect: "non-scaling-stroke",
    d: "M117.48 276.57c-4.05-1.97-8.37-2.5-12.29-4.66q-3.85-2.13-7.63-3.61"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fac1bf",
    vectorEffect: "non-scaling-stroke",
    d: "M97.56 268.3q-.93-2.97.19-6.24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c1e7ff",
    vectorEffect: "non-scaling-stroke",
    d: "M97.75 262.06q2.89-31.29 7.78-62.3 1.05-6.72 2.04-21.97"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff80ab",
    vectorEffect: "non-scaling-stroke",
    d: "m107.57 177.79.9-14.67"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fac1bf",
    vectorEffect: "non-scaling-stroke",
    d: "M108.47 163.12q7.49 1.25 10.92-4.52"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cfeef6",
    vectorEffect: "non-scaling-stroke",
    d: "M119.39 158.6q13.87-2.31 27.2-7.34.65-.24.66.45c0 5.59-.48 10.24.55 15.74"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#96aed4",
    vectorEffect: "non-scaling-stroke",
    d: "M147.8 167.45q.49 23.26 2.68 36.05 5.02 29.26 7.9 58.82.1 1 1.66.82"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fac1bf",
    vectorEffect: "non-scaling-stroke",
    d: "M160.04 263.14q-.13.8-.67 1.18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c1e7ff",
    vectorEffect: "non-scaling-stroke",
    d: "M159.37 264.32c-7.45 6.27-12.54 8.57-20.16 12.46"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#96aed4",
    vectorEffect: "non-scaling-stroke",
    d: "M139.21 276.78q-1.65.53-.89 2.79.16.47.62.64c7.81 2.86 21.28 1.66 31.39 1.47q.51-.01.7-.48.7-1.69-.71-3.78"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c1e7ff",
    vectorEffect: "non-scaling-stroke",
    d: "M170.32 277.42q-.22-5.12-2.07-10.37"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fac1bf",
    vectorEffect: "non-scaling-stroke",
    d: "m168.25 267.05-.87-4.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#96aed4",
    vectorEffect: "non-scaling-stroke",
    d: "M167.38 263.01q2.23.29 2.33-.71 1.62-16.12.6-32.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8da1ba",
    vectorEffect: "non-scaling-stroke",
    d: "m170.31 230.01 5.07-.13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#96aed4",
    vectorEffect: "non-scaling-stroke",
    d: "m175.38 229.88 6.36 32.55q.1.54.61.72l.9.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fac1bf",
    vectorEffect: "non-scaling-stroke",
    d: "m183.25 263.48.55 3.45"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c1e7ff",
    vectorEffect: "non-scaling-stroke",
    d: "m183.8 266.93.26 10.87"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#96aed4",
    vectorEffect: "non-scaling-stroke",
    d: "M184.06 277.8q-.34 1.85.02 3.4.12.55.69.55h14.13a1.56 1.55-84.9 0 0 1.53-1.28q.25-1.38-.8-2.92"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c1e7ff",
    vectorEffect: "non-scaling-stroke",
    d: "m199.63 277.55-7.57-12.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fac1bf",
    vectorEffect: "non-scaling-stroke",
    d: "m192.06 265.28-.06-2.23"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#96aed4",
    vectorEffect: "non-scaling-stroke",
    d: "M192 263.05c1.69-.85.31-29.67.07-33.38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8da1ba",
    vectorEffect: "non-scaling-stroke",
    d: "m192.07 229.67 14.69-.61q3.35-.14 3.31-3.31-.19-13.09-2.76-30.19"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8596a9",
    vectorEffect: "non-scaling-stroke",
    d: "m207.31 195.56-9.28.33q-.47.02-.51-.45-.47-5.17-4.67-7.96"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fac1bf",
    vectorEffect: "non-scaling-stroke",
    d: "m192.85 187.48-1.36-12.16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cfeef6",
    vectorEffect: "non-scaling-stroke",
    d: "m191.49 175.32 3.12-11.99"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c1e7ff",
    vectorEffect: "non-scaling-stroke",
    d: "m194.61 163.33 7.89 11.74q.28.43.79.43h5.65q.88 0 .38-.73l-9.69-14.26a.66.65 45.6 0 1 0-.75l9.82-14.4a.43.42 16 0 0-.37-.66l-5.91.21a1.02 1.02 0 0 0-.79.43l-5.16 7.44"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cfeef6",
    vectorEffect: "non-scaling-stroke",
    d: "M197.22 152.78c2.37-13.82.24-28.06-3.25-41.55"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dff4f9",
    vectorEffect: "non-scaling-stroke",
    d: "M193.97 111.23c4.25-.19 21.46 1.25 22.87-3.91 1.02-3.74 2.36-11.02.74-14.81q-.68-1.6-1.28-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cfeef6",
    vectorEffect: "non-scaling-stroke",
    d: "M216.3 89.51q8.36-8.35 3.51-18.44"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#adcceb",
    vectorEffect: "non-scaling-stroke",
    d: "M219.81 71.07c.95-1.03 7.11-6.5 3.47-7.52q-.49-.14-.86.21l-4.63 4.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#edf9fc",
    vectorEffect: "non-scaling-stroke",
    d: "m217.79 68.09-.75-.35"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c1e7ff",
    vectorEffect: "non-scaling-stroke",
    d: "M217.04 67.74q.16-.04.32-.09"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dff4f9",
    vectorEffect: "non-scaling-stroke",
    d: "M217.36 67.65q1.73-5 1.47-10.17-.04-.87-.92-.89l-17.4-.4q-1.17-.03-1.16-1.19c.03-5.49-1.77-9.49-7.7-9.84-6.17-.36-8.57 5-7.84 10.53q.07.55-.47.54l-18.55-.18q-.71-.01-.71.7l-.02 10.99"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a1dcf9",
    vectorEffect: "non-scaling-stroke",
    d: "M217.36 67.65c-7.37-6.54-17.72-4.88-22.86 3.02"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8dc1e5",
    vectorEffect: "non-scaling-stroke",
    d: "m194.5 70.67-1.19 2.89"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#afe3f0",
    vectorEffect: "non-scaling-stroke",
    d: "M193.31 73.56c-3.99 13.83 11 24.62 22.99 15.95M193.97 111.23c-2.29-8.41-12.07-10.83-18.63-12.98"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a1dcf9",
    vectorEffect: "non-scaling-stroke",
    d: "m175.34 98.25-1.62-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#76a3ce",
    vectorEffect: "non-scaling-stroke",
    d: "M173.72 96.25c.26-.97-.64-1.34-1.55-1.22"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dab6b9",
    vectorEffect: "non-scaling-stroke",
    d: "M172.17 95.03q-1.17-1.72-.76-4.78"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6d96b4",
    vectorEffect: "non-scaling-stroke",
    d: "M171.41 90.25c3.52-4.57 6.52-9.25 4.37-15.26q-2.94-8.22-11.72-7.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7cbbe2",
    vectorEffect: "non-scaling-stroke",
    d: "m219.81 71.07-1.11 1.12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9bc5e8",
    vectorEffect: "non-scaling-stroke",
    d: "m218.7 72.19-1.62 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6eb3eb",
    vectorEffect: "non-scaling-stroke",
    d: "m217.08 73.99-9.4 9.58a.85.85 0 0 1-1.14.07l-10.69-8.54"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9bc5e8",
    vectorEffect: "non-scaling-stroke",
    d: "m195.85 75.1-.89-.66"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7cbbe2",
    vectorEffect: "non-scaling-stroke",
    d: "M194.96 74.44q.02-.7-1.65-.88"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9bc5e8",
    vectorEffect: "non-scaling-stroke",
    d: "m195.67 70.97 1.67 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6eb3eb",
    vectorEffect: "non-scaling-stroke",
    d: "m197.34 72.37 9.35 7.29q.42.33.79-.06l8.03-8.65"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9bc5e8",
    vectorEffect: "non-scaling-stroke",
    d: "m215.51 70.95 2.28-2.86"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#917094",
    vectorEffect: "non-scaling-stroke",
    d: "M172.17 95.03q.09.73.67 1.55"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bca8bf",
    vectorEffect: "non-scaling-stroke",
    d: "M172.84 96.58q-3 2.88-7.69 3.61"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cab0b6",
    vectorEffect: "non-scaling-stroke",
    d: "M165.15 100.19q-3.52 1.09-5.21-.82"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#90d6f6",
    vectorEffect: "non-scaling-stroke",
    d: "m197.22 152.78-2.61 10.55"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cab0b6",
    vectorEffect: "non-scaling-stroke",
    d: "m191.49 175.32-8.54-.73"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#669dcb",
    vectorEffect: "non-scaling-stroke",
    d: "M182.95 174.59q-1.04-2.17-.24-5.4a.42.42 0 0 0-.5-.51q-17.72 3.85-34.41-1.23"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cab0b6",
    vectorEffect: "non-scaling-stroke",
    d: "M119.39 158.6q-.16-4.6-1.85-9.13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cfeef6",
    vectorEffect: "non-scaling-stroke",
    d: "m117.54 149.47 21.71-10.19q.48-.23.54-.76l.99-9.05"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ce6fa1",
    vectorEffect: "non-scaling-stroke",
    d: "M140.78 129.47q1.67-5.83.81-11.91"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#afe0fc",
    vectorEffect: "non-scaling-stroke",
    d: "M217.04 67.74q0 .17-.03.29-.1.33-.39.14-11.92-7.81-20.95 2.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6eb3eb",
    vectorEffect: "non-scaling-stroke",
    d: "M195.67 70.97q-.34-.24-1.17-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5896d4",
    vectorEffect: "non-scaling-stroke",
    d: "M173.72 96.25q-.39.26-.88.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#90d6f6",
    vectorEffect: "non-scaling-stroke",
    d: "M175.34 98.25q-2.36 4.01-8.17 5.21a1.44 1.44 0 0 1-1.72-1.2l-.3-2.07"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bde8f2",
    vectorEffect: "non-scaling-stroke",
    d: "M194.96 74.44q-1.59-.09-1.48 2.29c.95 22.49 31.74 18.04 26.19-3.96q-.12-.49-.62-.54l-.35-.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#88627a",
    vectorEffect: "non-scaling-stroke",
    d: "M171.41 90.25q-1.2-.58-1.63-1.48-.21-.44.09-.83 1.02-1.3 1.4-2.84a1.59 1.59 0 0 0-2.55-1.61l-1.45 1.2a.64.64 0 0 1-.96-.19q-1.47-2.7-4.2-3.89a.79.79 0 0 1-.46-.86l.67-3.87a.52.52 0 0 0-.41-.6l-7.34-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#afe0fc",
    vectorEffect: "non-scaling-stroke",
    d: "M215.51 70.95c-5.82-5.82-13.35-5.02-18.17 1.42M195.85 75.1c-1.62 20.7 27.13 16.6 21.23-1.11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#805869",
    vectorEffect: "non-scaling-stroke",
    d: "m192.85 187.48-2.18 2.53"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fac1bf",
    vectorEffect: "non-scaling-stroke",
    d: "M190.67 190.01q-1.03.82-1.18 1.61"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#917094",
    vectorEffect: "non-scaling-stroke",
    d: "m189.49 191.62-4.34 1.8a1.05 1.03 48.9 0 1-.95-.07l-3.64-2.21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#805869",
    vectorEffect: "non-scaling-stroke",
    d: "M180.56 191.14q.78-1.22 2.08-1.33a.52.52 0 0 0 .47-.57l-.16-1.83q-.04-.49-.52-.44l-1.42.15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fac1bf",
    vectorEffect: "non-scaling-stroke",
    d: "M117.54 149.47q-2.08.73-4.76.51a.72.72 0 0 1-.63-.51q-.39-1.36-2.63-1.65"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#917094",
    vectorEffect: "non-scaling-stroke",
    d: "M182.95 174.59q-1.85 3.27-2.28 6.62c-.22 1.79.43 3.8.34 5.91"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1c457e",
    vectorEffect: "non-scaling-stroke",
    d: "M181.01 187.12c-4.65 1.2-4.76 4.4-5.52 8.25q-.1.55-.66.54l-6.49-.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#24508f",
    vectorEffect: "non-scaling-stroke",
    d: "m168.34 195.81-2.22-14.01q-.05-.31-.11 0-1.42 7.68.79 14.51"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1c457e",
    vectorEffect: "non-scaling-stroke",
    d: "M166.8 196.31q-1.91.88-2.31 2.94-1.33 6.88-4.16 24.15-.08.5.23.89 2.54 3.15 6.01 5.05"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#24508f",
    vectorEffect: "non-scaling-stroke",
    d: "M166.57 229.34q1.79.81 3.74.67"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#917094",
    vectorEffect: "non-scaling-stroke",
    d: "m167.38 263.01-7.34.13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fa416b",
    vectorEffect: "non-scaling-stroke",
    d: "m108.47 163.12-7.2-1.19"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bca8bf",
    vectorEffect: "non-scaling-stroke",
    d: "M101.27 161.93q-1.88-1.55-4.37-1.35"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff80ab",
    vectorEffect: "non-scaling-stroke",
    d: "M140.78 129.47c-3.75 3.64-10.55 9.58-14.84 11-5.21 1.74-11.75-4.14-15.77-7.35q-.6-.48-.6.29l-.05 14.41"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fa416b",
    vectorEffect: "non-scaling-stroke",
    d: "m109.52 147.82-8.7 2.37"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff80ab",
    vectorEffect: "non-scaling-stroke",
    d: "M100.82 150.19q-.3-19.88-1.82-30.69-1.31-9.28-6.24-17.76"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1c457e",
    vectorEffect: "non-scaling-stroke",
    d: "M180.56 191.14q-1.73 1.04-1.59 4.02.02.52.55.53l9.69.15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8596a9",
    vectorEffect: "non-scaling-stroke",
    d: "m189.21 195.84 4.75.12q.49.02.46-.48-.21-3.9-3.75-5.47"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#133864",
    vectorEffect: "non-scaling-stroke",
    d: "m207.31 195.56-13.8 16.72"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1c457e",
    vectorEffect: "non-scaling-stroke",
    d: "M193.51 212.28q-2.79-2.74-9.65-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#133864",
    vectorEffect: "non-scaling-stroke",
    d: "M183.86 211.11q-2.43.06-4.58-2.42-4.57-5.28-9.7-10.21-1.17-1.12-2.1.21c-.08.12.11 1.75.1 2.08q-.73 14.17-1.01 28.57"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#96aed4",
    vectorEffect: "non-scaling-stroke",
    d: "m189.21 195.84.28-4.22"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#133864",
    vectorEffect: "non-scaling-stroke",
    d: "m168.34 195.81-1.54.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bca8bf",
    vectorEffect: "non-scaling-stroke",
    d: "m168.25 267.05-4.05 2.02q-.49.25-.85-.16l-3.98-4.59"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#24508f",
    vectorEffect: "non-scaling-stroke",
    d: "m192.07 229.67-16.69.21M183.86 211.11q-.83 2.62-.21 5.27a.81.81 0 0 0 .79.62l7.29-.01a1.04 1.04 0 0 0 1.03-1.22q-.28-1.67.75-3.49"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c067ab",
    vectorEffect: "non-scaling-stroke",
    d: "M101.27 161.93c.16 4.45 1.3 14.06 6.3 15.86"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bca8bf",
    vectorEffect: "non-scaling-stroke",
    d: "m97.75 262.06-9.66-.28M72.79 262.43l-7.49-.16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fac1bf",
    vectorEffect: "non-scaling-stroke",
    d: "M100.82 150.19q-1.21 1.18-2.89.71"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff80ab",
    vectorEffect: "non-scaling-stroke",
    d: "M78.87 98.98q9.7 22.71 10.6 47.5.02.49.49.66 3.75 1.34 7.44 2.23.75.18.53 1.53"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fa416b",
    vectorEffect: "non-scaling-stroke",
    d: "M97.93 150.9q-2.3 4.59-1.03 9.68"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c067ab",
    vectorEffect: "non-scaling-stroke",
    d: "m96.9 160.58-5.4-.54q-.5-.05-.49.45c.34 17.16-7.18 21.22-23.02 21.41"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fa416b",
    vectorEffect: "non-scaling-stroke",
    d: "m91.71 98.68 1.05 3.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fac1bf",
    vectorEffect: "non-scaling-stroke",
    d: "M92.76 101.74q-6.31 2.43-12.92-2.52a1.05 1.03 65 0 0-.56-.21l-.41-.03"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fa416b",
    vectorEffect: "non-scaling-stroke",
    d: "M78.87 98.98q-.59-.46-.92-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dab6b9",
    vectorEffect: "non-scaling-stroke",
    d: "M77.95 97.68q1.02-1.55 1.28-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5896d4",
    vectorEffect: "non-scaling-stroke",
    d: "M170.32 277.42q-15.6 1.76-31.11-.64"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#917094",
    vectorEffect: "non-scaling-stroke",
    d: "m192 263.05-8.75.43M97.56 268.3c-3.57 3.55-6.08 1.3-9.94 2.15M71.97 269.18q-3.09-2.25-7.77-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#df75a5",
    vectorEffect: "non-scaling-stroke",
    d: "M77.95 97.68q-7.89 3.76-15.11 8.64c-3.12 2.11-3.78 3.87-3.71 7.49.21 11.68.67 24.95 4.78 35.05"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cdeef6",
    vectorEffect: "non-scaling-stroke",
    d: "M57.3 149.37q-2.42-1.88-2.86-7.05-.04-.5-.4-.86l-2.56-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a1dcf9",
    vectorEffect: "non-scaling-stroke",
    d: "M51.48 138.96q1.58.3 2.78-.19.47-.2.47-.72l.05-33.02a.55.55 0 0 0-.56-.55l-4.14.06a.59.59 0 0 0-.58.59l-.03 7.64"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cdeef6",
    vectorEffect: "non-scaling-stroke",
    d: "m49.47 112.77-.48-6.97q-.03-.49-.38-.85-3.9-3.92-3.63-9.46.02-.24-.23-.24-.2 0-.42.01a.1.1 0 0 1-.04-.19l1.49-.56"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#88627a",
    vectorEffect: "non-scaling-stroke",
    d: "M97.36 77.97q-.33-2.49-1.48-4.43-.24-.39-.69-.33l-7.25.86q-.61.07-.73.68l-.81 3.9q-.08.41-.5.48l-2.32.37a.7.69-4 0 0-.59.67q-.05 1.7-.99 3.01a.48.47 46.8 0 1-.79-.03q-.7-1.15-1.94-1.14a1.56 1.56 0 0 0-1.16 2.59l2.37 2.67a1.13 1.13 0 0 1 .28.77q-.01.94-.68 1.42"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bca8bf",
    vectorEffect: "non-scaling-stroke",
    d: "M192.06 265.28q-4.99-.9-8.26 1.65"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#24508f",
    vectorEffect: "non-scaling-stroke",
    d: "m117.48 276.57-.54 1.26q-.17.39-.59.39l-30.98.01M71.98 278.16q-6.68.97-13.29-.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#afe0fc",
    vectorEffect: "non-scaling-stroke",
    d: "M49.47 112.77q.05 12.59.04 25.23-.01 1.39 1.97.96M32.65 139.06l4.44-.09q.66-.02.66-.67v-16.44q0-.56-.57-.57l-3.65-.04a1.08 1.07-88.7 0 0-1.09 1.05l-.13 5.73"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5896d4",
    vectorEffect: "non-scaling-stroke",
    d: "m199.63 277.55-15.57.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dff4f9",
    vectorEffect: "non-scaling-stroke",
    d: "M137.002 58.714a.67.67 0 0 0-.666-.674l-22.88-.12a.67.67 0 0 0-.673.667l-.045 8.62a.67.67 0 0 0 .666.673l22.88.12a.67.67 0 0 0 .673-.667l.045-8.62"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cfeef6",
    vectorEffect: "non-scaling-stroke",
    d: "M136.908 73.701a.45.45 0 0 0-.45-.45l-23.24-.041a.45.45 0 0 0-.45.449l-.016 8.98a.45.45 0 0 0 .45.45l23.24.041a.45.45 0 0 0 .45-.449l.016-8.98M137 88.95a.45.45 0 0 0-.45-.45h-23.34a.45.45 0 0 0-.45.45v9.1a.45.45 0 0 0 .45.45h23.34a.45.45 0 0 0 .45-.45v-9.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c1e7ff",
    vectorEffect: "non-scaling-stroke",
    d: "M29.218 129.846a.97.97 0 0 0-.975-.965l-3.28.018a.97.97 0 0 0-.964.975l.043 8.2a.97.97 0 0 0 .975.964l3.28-.017a.97.97 0 0 0 .964-.975l-.043-8.2M211.73 148.04q-3.81 5.47-8 11.42a1.18 1.16-45.3 0 0 0 1.33l9.82 14.19q.36.52.98.52h5.76q.79 0 .34-.65L211 161.1a1.7 1.69-44.9 0 1 .01-1.96l9.56-13.42q.42-.59-.28-.78-2.62-.75-4.82-.11-1.89.55-3.74 3.21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#adcceb",
    vectorEffect: "non-scaling-stroke",
    d: "M231.21 175.6q.3.31.58-.01.38-.44.05-.91l-9.71-14.08a.84.84 0 0 1 .01-.95l9.89-14.16a.46.46 0 0 0-.37-.73l-5.38-.01a1.76 1.75-72.5 0 0-1.47.77l-9.66 14.22a.81.8-45.5 0 0 0 .91l9.78 14.35a1.14 1.13 72.7 0 0 .94.5h5.1a.34.34 0 0 1 .24.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cfeef6",
    vectorEffect: "non-scaling-stroke",
    d: "m50.71 189.97.35-6.47a.63.63 0 0 1 .95-.51q1.69.99 2.6 2.76.22.43.7.45l2.79.07q3.08.08 1.77-2.71-2.55-5.46-8.67-6.3a.62.61 11.4 0 1-.51-.76q.53-2.1-1.07-3.33a.62.62 0 0 0-.98.34l-.76 3.14q-.1.42-.52.5c-12.06 2.36-11.66 15.53.06 17.86a.73.71 6 0 1 .58.7v6.53a.56.56 0 0 1-.73.54q-2.35-.74-3.58-2.9a1.02 1.01-12.2 0 0-.78-.5l-3.13-.31a1.57 1.57 0 0 0-1.61 2.15q2.47 6.22 9.22 7.07a.75.75 0 0 1 .64.89q-.19 1.02.02 1.8a1.5 1.5 0 0 0 2.95-.41v-1.79q0-.66.66-.69c4.48-.22 7.99-3.02 8.45-7.59.58-5.77-3.96-8.58-8.95-9.91a.6.6 0 0 1-.45-.62"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#afe0fc",
    vectorEffect: "non-scaling-stroke",
    d: "M46.262 112.865a.87.87 0 0 0-.868-.872l-3.5-.006a.87.87 0 0 0-.872.868l-.044 25.38a.87.87 0 0 0 .868.872l3.5.006a.87.87 0 0 0 .872-.868l.044-25.38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6eb3eb",
    vectorEffect: "non-scaling-stroke",
    d: "m86.18 204.22 1.83.45a.25.25 0 0 0 .3-.18l.02-.08a25.43.84-76.1 0 0 5.29-24.89l-.68-.17a25.43.84-76.1 0 0-6.92 24.49l-.02.07a.25.25 0 0 0 .18.31"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cfeef6",
    vectorEffect: "non-scaling-stroke",
    d: "m47.94 188.63.14-5.16a.63.63 0 0 0-.62-.64l-.23-.01a3.14 3.12 1.5 0 0-3.22 3.04v.18a3.14 3.12 1.5 0 0 3.06 3.2h.23a.63.63 0 0 0 .64-.61M51.02 196.83l.02 5.54a.29.29 0 0 0 .3.29h.2a2.99 2.98-.3 0 0 2.97-3v-.16a2.99 2.98-.3 0 0-3.01-2.96h-.2a.29.29 0 0 0-.28.29"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h256v299H0V0zm113.1 52.27 23.27-.01q.63 0 .63-.63v-7.88a1 1 0 0 1 1-1h6.92q.78 0 .29-.61l-19.23-23.51a1.32 1.31-44.6 0 0-2.02-.01l-19.38 23.05a.88.87-72 0 0 .73 1.44l6.48-.47a.89.89 0 0 1 .96.89v8.39q0 .35.35.35zm50.96 15.47c-3.62.98-8.27 2.26-9.49 6.14-4.36 3.81-1.09 8.7-4.49 13.55q-.31.43.14.71l1.55.96a.94.94 0 0 1 .44.72c.31 3.55 2.08 8.42 6.76 6.49q.51-.21.78.28.55 1 .19 2.78c-4.8 2.57-11.83 4.27-14.31 9.23q-2.29 4.58-4.04 8.96l-.13-.82a1.15 1.15 0 0 0-1.79-.77l-14.28 9.84a1.25 1.24-36.9 0 1-1.66-.23l-16.66-19.9a4.63 4.61 81.3 0 0-1.72-1.27l-13.64-5.73q-1.04-1.79-.12-3.98.19-.46.69-.5c7.2-.64 5.32-10.3 5.08-16.23q2.55-6.46-3.33-8.29c-1.99-.62-12.58-3.23-15.59-.99-9.29 6.9-3.63 14.07 1.64 20.77l-.85 4.96-14.45.06q-.65.01-.5-.62c2.92-12.85-16.41-15.5-15.43.03a.54.54 0 0 1-.52.57l-2.55.05-14.93.44a1.61 1.61 0 0 0-1.56 1.63q.19 10.84.79 21.93c.16 3.04 1.02 5.95 1.68 8.93q.02.09.09.02l.19-.23q.15-.18.18.05l.09.75.34 11.03q-1.09 1.05-.55 3.22.12.45.58.52c1.62.24 2.93 3.85 3.42 5.71a.75.74 85.5 0 0 .65.56q10.76.88 20.55.3 3.91.49 6.61-.51l3.81 3.64q.35.34.35.82l-.08 28.58c-.55 12.17.23 24.58-1.5 36.57q-3.03 21.02-3.89 42.28-.01.47.42.63l2.28.89-1.1 5.85-5.51 9.84c-1.3 2.34-1.33 4.09 1.86 4.08q5.47-.03 10.83-.05.57 0 .58-.57l.02-3.26-.01-8.98.82-6.75q1.56.08 2.51-.43.43-.23.49-.72 3.46-28.13 9.84-55.73a.59.59 0 0 1 1.17.11c.22 7.84-1.51 15.18-2.3 22.93-1.07 10.45-.57 21.57-.32 32.15a.63.63 0 0 0 .55.6l3.36.44-.47 8.67-2.25 7.78q-.58 1.67-.33 2.71a.72.72 0 0 0 .7.56h32.12q.6 0 .87-.53 1.06-2.08-1.25-4.4c-4.05-1.97-8.37-2.5-12.29-4.66q-3.85-2.13-7.63-3.61-.93-2.97.19-6.24 2.89-31.29 7.78-62.3 1.05-6.72 2.04-21.97l.9-14.67q7.49 1.25 10.92-4.52 13.87-2.31 27.2-7.34.65-.24.66.45c0 5.59-.48 10.24.55 15.74q.49 23.26 2.68 36.05 5.02 29.26 7.9 58.82.1 1 1.66.82-.13.8-.67 1.18c-7.45 6.27-12.54 8.57-20.16 12.46q-1.65.53-.89 2.79.16.47.62.64c7.81 2.86 21.28 1.66 31.39 1.47q.51-.01.7-.48.7-1.69-.71-3.78-.22-5.12-2.07-10.37l-.87-4.04q2.23.29 2.33-.71 1.62-16.12.6-32.29l5.07-.13 6.36 32.55q.1.54.61.72l.9.33.55 3.45.26 10.87q-.34 1.85.02 3.4.12.55.69.55h14.13a1.56 1.55-84.9 0 0 1.53-1.28q.25-1.38-.8-2.92l-7.57-12.27-.06-2.23c1.69-.85.31-29.67.07-33.38l14.69-.61q3.35-.14 3.31-3.31-.19-13.09-2.76-30.19l-9.28.33q-.47.02-.51-.45-.47-5.17-4.67-7.96l-1.36-12.16 3.12-11.99 7.89 11.74q.28.43.79.43h5.65q.88 0 .38-.73l-9.69-14.26a.66.65 45.6 0 1 0-.75l9.82-14.4a.43.42 16 0 0-.37-.66l-5.91.21a1.02 1.02 0 0 0-.79.43l-5.16 7.44c2.37-13.82.24-28.06-3.25-41.55 4.25-.19 21.46 1.25 22.87-3.91 1.02-3.74 2.36-11.02.74-14.81q-.68-1.6-1.28-3 8.36-8.35 3.51-18.44c.95-1.03 7.11-6.5 3.47-7.52q-.49-.14-.86.21l-4.63 4.33-.75-.35q.16-.04.32-.09 1.73-5 1.47-10.17-.04-.87-.92-.89l-17.4-.4q-1.17-.03-1.16-1.19c.03-5.49-1.77-9.49-7.7-9.84-6.17-.36-8.57 5-7.84 10.53q.07.55-.47.54l-18.55-.18q-.71-.01-.71.7l-.02 10.99zm-27.058-9.026a.67.67 0 0 0-.666-.674l-22.88-.12a.67.67 0 0 0-.673.667l-.045 8.62a.67.67 0 0 0 .666.673l22.88.12a.67.67 0 0 0 .673-.667l.045-8.62zm-.094 14.987a.45.45 0 0 0-.45-.45l-23.24-.041a.45.45 0 0 0-.45.449l-.016 8.98a.45.45 0 0 0 .45.45l23.24.041a.45.45 0 0 0 .45-.449l.016-8.98zM137 88.95a.45.45 0 0 0-.45-.45h-23.34a.45.45 0 0 0-.45.45v9.1a.45.45 0 0 0 .45.45h23.34a.45.45 0 0 0 .45-.45v-9.1zM29.219 129.846a.97.97 0 0 0-.976-.965l-3.28.018a.97.97 0 0 0-.964.975l.043 8.2a.97.97 0 0 0 .975.964l3.28-.017a.97.97 0 0 0 .964-.975l-.043-8.2zM211.73 148.04q-3.81 5.47-8 11.42a1.18 1.16-45.3 0 0 0 1.33l9.82 14.19q.36.52.98.52h5.76q.79 0 .34-.65L211 161.1a1.7 1.69-44.9 0 1 .01-1.96l9.56-13.42q.42-.59-.28-.78-2.62-.75-4.82-.11-1.89.55-3.74 3.21zm19.48 27.56q.3.31.58-.01.38-.44.05-.91l-9.71-14.08a.84.84 0 0 1 .01-.95l9.89-14.16a.46.46 0 0 0-.37-.73l-5.38-.01a1.76 1.75-72.5 0 0-1.47.77l-9.66 14.22a.81.8-45.5 0 0 0 .91l9.78 14.35a1.14 1.13 72.7 0 0 .94.5h5.1a.34.34 0 0 1 .24.1zm-180.5 14.37.35-6.47a.63.63 0 0 1 .95-.51q1.69.99 2.6 2.76.22.43.7.45l2.79.07q3.08.08 1.77-2.71-2.55-5.46-8.67-6.3a.62.61 11.4 0 1-.51-.76q.53-2.1-1.07-3.33a.62.62 0 0 0-.98.34l-.76 3.14q-.1.42-.52.5c-12.06 2.36-11.66 15.53.06 17.86a.73.71 6 0 1 .58.7v6.53a.56.56 0 0 1-.73.54q-2.35-.74-3.58-2.9a1.02 1.01-12.2 0 0-.78-.5l-3.13-.31a1.57 1.57 0 0 0-1.61 2.15q2.47 6.22 9.22 7.07a.75.75 0 0 1 .64.89q-.19 1.02.02 1.8a1.5 1.5 0 0 0 2.95-.41v-1.79q0-.66.66-.69c4.48-.22 7.99-3.02 8.45-7.59.58-5.77-3.96-8.58-8.95-9.91a.6.6 0 0 1-.45-.62z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbf2f8",
    d: "M113.1 52.27q-.35 0-.35-.35v-8.39a.89.89 0 0 0-.96-.89l-6.48.47a.88.87-72 0 1-.73-1.44l19.38-23.05a1.32 1.31-44.6 0 1 2.02.01l19.23 23.51q.49.61-.29.61H138a1 1 0 0 0-1 1v7.88q0 .63-.63.63l-23.27.01z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bfe9f3",
    d: "M217.36 67.65c-7.37-6.54-17.72-4.88-22.86 3.02l-1.19 2.89c-3.99 13.83 11 24.62 22.99 15.95q.6 1.4 1.28 3c1.62 3.79.28 11.07-.74 14.81-1.41 5.16-18.62 3.72-22.87 3.91-2.29-8.41-12.07-10.83-18.63-12.98l-1.62-2c.26-.97-.64-1.34-1.55-1.22q-1.17-1.72-.76-4.78c3.52-4.57 6.52-9.25 4.37-15.26q-2.94-8.22-11.72-7.25l.02-10.99q0-.71.71-.7l18.55.18q.54.01.47-.54c-.73-5.53 1.67-10.89 7.84-10.53 5.93.35 7.73 4.35 7.7 9.84q-.01 1.16 1.16 1.19l17.4.4q.88.02.92.89.26 5.17-1.47 10.17z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#bfe9f3",
    x: -12.11,
    y: -4.98,
    transform: "rotate(.3 -11962.012 23879.839)",
    width: 24.22,
    height: 9.96,
    rx: 0.67
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#82ceff",
    d: "M217.36 67.65q-.16.05-.32.09 0 .17-.03.29-.1.33-.39.14-11.92-7.81-20.95 2.8-.34-.24-1.17-.3c5.14-7.9 15.49-9.56 22.86-3.02z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5a98d7",
    d: "m219.81 71.07-1.11 1.12-1.62 1.8-9.4 9.58a.85.85 0 0 1-1.14.07l-10.69-8.54-.89-.66q.02-.7-1.65-.88l1.19-2.89q.83.06 1.17.3l1.67 1.4 9.35 7.29q.42.33.79-.06l8.03-8.65 2.28-2.86 4.63-4.33q.37-.35.86-.21c3.64 1.02-2.52 6.49-3.47 7.52z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbf2f8",
    d: "m217.04 67.74.75.35-2.28 2.86c-5.82-5.82-13.35-5.02-18.17 1.42l-1.67-1.4q9.03-10.61 20.95-2.8.29.19.39-.14.03-.12.03-.29z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#82ceff",
    d: "m215.51 70.95-8.03 8.65q-.37.39-.79.06l-9.35-7.29c4.82-6.44 12.35-7.24 18.17-1.42z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b4274",
    d: "M171.41 90.25q-1.2-.58-1.63-1.48-.21-.44.09-.83 1.02-1.3 1.4-2.84a1.59 1.59 0 0 0-2.55-1.61l-1.45 1.2a.64.64 0 0 1-.96-.19q-1.47-2.7-4.2-3.89a.79.79 0 0 1-.46-.86l.67-3.87a.52.52 0 0 0-.41-.6l-7.34-1.4c1.22-3.88 5.87-5.16 9.49-6.14q8.78-.97 11.72 7.25c2.15 6.01-.85 10.69-4.37 15.26zM97.36 77.97q-.33-2.49-1.48-4.43-.24-.39-.69-.33l-7.25.86q-.61.07-.73.68l-.81 3.9q-.08.41-.5.48l-2.32.37a.7.69-4 0 0-.59.67q-.05 1.7-.99 3.01a.48.47 46.8 0 1-.79-.03q-.7-1.15-1.94-1.14a1.56 1.56 0 0 0-1.16 2.59l2.37 2.67a1.13 1.13 0 0 1 .28.77q-.01.94-.68 1.42c-5.27-6.7-10.93-13.87-1.64-20.77 3.01-2.24 13.6.37 15.59.99q5.88 1.83 3.33 8.29z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#9eddec",
    d: "M219.81 71.07q4.85 10.09-3.51 18.44c-11.99 8.67-26.98-2.12-22.99-15.95q1.67.18 1.65.88-1.59-.09-1.48 2.29c.95 22.49 31.74 18.04 26.19-3.96q-.12-.49-.62-.54l-.35-.04 1.11-1.12z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbf2f8",
    d: "m218.7 72.19.35.04q.5.05.62.54c5.55 22-25.24 26.45-26.19 3.96q-.11-2.38 1.48-2.29l.89.66c-1.62 20.7 27.13 16.6 21.23-1.11l1.62-1.8z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#9eddec",
    x: -12.07,
    y: -4.94,
    transform: "rotate(.1 -44725.684 71561.388)",
    width: 24.14,
    height: 9.88,
    rx: 0.45
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5827f",
    d: "M97.36 77.97c.24 5.93 2.12 15.59-5.08 16.23q-.5.04-.69.5-.92 2.19.12 3.98l1.05 3.06q-6.31 2.43-12.92-2.52a1.05 1.03 65 0 0-.56-.21l-.41-.03q-.59-.46-.92-1.3 1.02-1.55 1.28-3.26l.85-4.96q.67-.48.68-1.42a1.13 1.13 0 0 0-.28-.77l-2.37-2.67a1.56 1.56 0 0 1 1.16-2.59q1.24-.01 1.94 1.14a.48.47 46.8 0 0 .79.03q.94-1.31.99-3.01a.7.69-4 0 1 .59-.67l2.32-.37q.42-.07.5-.48l.81-3.9q.12-.61.73-.68l7.25-.86q.45-.06.69.33 1.15 1.94 1.48 4.43zM154.57 73.88l7.34 1.4a.52.52 0 0 1 .41.6l-.67 3.87a.79.79 0 0 0 .46.86q2.73 1.19 4.2 3.89a.64.64 0 0 0 .96.19l1.45-1.2a1.59 1.59 0 0 1 2.55 1.61q-.38 1.54-1.4 2.84-.3.39-.09.83.43.9 1.63 1.48-.41 3.06.76 4.78.09.73.67 1.55-3 2.88-7.69 3.61-3.52 1.09-5.21-.82.36-1.78-.19-2.78-.27-.49-.78-.28c-4.68 1.93-6.45-2.94-6.76-6.49a.94.94 0 0 0-.44-.72l-1.55-.96q-.45-.28-.14-.71c3.4-4.85.13-9.74 4.49-13.55z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#82ceff",
    d: "M217.08 73.99c5.9 17.71-22.85 21.81-21.23 1.11l10.69 8.54a.85.85 0 0 0 1.14-.07l9.4-9.58z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#bfe9f3",
    d: "M79.23 94.42q-.26 1.71-1.28 3.26-7.89 3.76-15.11 8.64c-3.12 2.11-3.78 3.87-3.71 7.49.21 11.68.67 24.95 4.78 35.05q-2.7 1-6.61.51-2.42-1.88-2.86-7.05-.04-.5-.4-.86l-2.56-2.5q1.58.3 2.78-.19.47-.2.47-.72l.05-33.02a.55.55 0 0 0-.56-.55l-4.14.06a.59.59 0 0 0-.58.59l-.03 7.64-.48-6.97q-.03-.49-.38-.85-3.9-3.92-3.63-9.46.02-.24-.23-.24-.2 0-.42.01a.1.1 0 0 1-.04-.19l1.49-.56 2.55-.05a.54.54 0 0 0 .52-.57c-.98-15.53 18.35-12.88 15.43-.03q-.15.63.5.62l14.45-.06z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#9eddec",
    x: 112.76,
    y: 88.5,
    width: 24.24,
    height: 10,
    rx: 0.45
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbf2f8",
    d: "m45.78 94.51-1.49.56a.1.1 0 0 0 .04.19q.22-.01.42-.01.25 0 .23.24-.27 5.54 3.63 9.46.35.36.38.85l.48 6.97q.05 12.59.04 25.23-.01 1.39 1.97.96l2.56 2.5q.36.36.4.86.44 5.17 2.86 7.05-9.79.58-20.55-.3a.75.74 85.5 0 1-.65-.56c-.49-1.86-1.8-5.47-3.42-5.71q-.46-.07-.58-.52-.54-2.17.55-3.22l4.44-.09q.66-.02.66-.67v-16.44q0-.56-.57-.57l-3.65-.04a1.08 1.07-88.7 0 0-1.09 1.05l-.13 5.73-.09-.75q-.03-.23-.18-.05l-.19.23q-.07.07-.09-.02c-.66-2.98-1.52-5.89-1.68-8.93q-.6-11.09-.79-21.93a1.61 1.61 0 0 1 1.56-1.63l14.93-.44zm.482 18.355a.87.87 0 0 0-.868-.872l-3.5-.006a.87.87 0 0 0-.872.868l-.044 25.38a.87.87 0 0 0 .868.872l3.5.006a.87.87 0 0 0 .872-.868l.044-25.38z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d5da9",
    d: "M172.17 95.03c.91-.12 1.81.25 1.55 1.22q-.39.26-.88.33-.58-.82-.67-1.55z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#82ceff",
    d: "m173.72 96.25 1.62 2q-2.36 4.01-8.17 5.21a1.44 1.44 0 0 1-1.72-1.2l-.3-2.07q4.69-.73 7.69-3.61.49-.07.88-.33z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe0056",
    d: "M77.95 97.68q.33.84.92 1.3 9.7 22.71 10.6 47.5.02.49.49.66 3.75 1.34 7.44 2.23.75.18.53 1.53-2.3 4.59-1.03 9.68l-5.4-.54q-.5-.05-.49.45c.34 17.16-7.18 21.22-23.02 21.41l.08-28.58q0-.48-.35-.82l-3.81-3.64c-4.11-10.1-4.57-23.37-4.78-35.05-.07-3.62.59-5.38 3.71-7.49q7.22-4.88 15.11-8.64z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#9eddec",
    d: "M175.34 98.25c6.56 2.15 16.34 4.57 18.63 12.98 3.49 13.49 5.62 27.73 3.25 41.55l-2.61 10.55-3.12 11.99-8.54-.73q-1.04-2.17-.24-5.4a.42.42 0 0 0-.5-.51q-17.72 3.85-34.41-1.23c-1.03-5.5-.55-10.15-.55-15.74q-.01-.69-.66-.45-13.33 5.03-27.2 7.34-.16-4.6-1.85-9.13l21.71-10.19q.48-.23.54-.76l.99-9.05q1.67-5.83.81-11.91 1.75-4.38 4.04-8.96c2.48-4.96 9.51-6.66 14.31-9.23q1.69 1.91 5.21.82l.3 2.07a1.44 1.44 0 0 0 1.72 1.2q5.81-1.2 8.17-5.21z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe0056",
    d: "m91.71 98.68 13.64 5.73a4.63 4.61 81.3 0 1 1.72 1.27l16.66 19.9a1.25 1.24-36.9 0 0 1.66.23l14.28-9.84a1.15 1.15 0 0 1 1.79.77l.13.82q.86 6.08-.81 11.91c-3.75 3.64-10.55 9.58-14.84 11-5.21 1.74-11.75-4.14-15.77-7.35q-.6-.48-.6.29l-.05 14.41-8.7 2.37q-.3-19.88-1.82-30.69-1.31-9.28-6.24-17.76l-1.05-3.06z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m78.87 98.98.41.03a1.05 1.03 65 0 1 .56.21q6.61 4.95 12.92 2.52 4.93 8.48 6.24 17.76 1.52 10.81 1.82 30.69-1.21 1.18-2.89.71.22-1.35-.53-1.53-3.69-.89-7.44-2.23-.47-.17-.49-.66-.9-24.79-10.6-47.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#82ceff",
    d: "M51.48 138.96q-1.98.43-1.97-.96.01-12.64-.04-25.23l.03-7.64a.59.59 0 0 1 .58-.59l4.14-.06a.55.55 0 0 1 .56.55l-.05 33.02q0 .52-.47.72-1.2.49-2.78.19z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#82ceff",
    x: -2.62,
    y: -13.56,
    transform: "rotate(.1 -71913.023 25055.188)",
    width: 5.24,
    height: 27.12,
    rx: 0.87
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#82ceff",
    d: "m32.65 139.06-.34-11.03.13-5.73a1.08 1.07-88.7 0 1 1.09-1.05l3.65.04q.57.01.57.57v16.44q0 .65-.66.67l-4.44.09z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#82ceff",
    x: -2.61,
    y: -5.07,
    transform: "rotate(-.3 25597.732 -5018.964)",
    width: 5.22,
    height: 10.14,
    rx: 0.97
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m140.78 129.47-.99 9.05q-.06.53-.54.76l-21.71 10.19q-2.08.73-4.76.51a.72.72 0 0 1-.63-.51q-.39-1.36-2.63-1.65l.05-14.41q0-.77.6-.29c4.02 3.21 10.56 9.09 15.77 7.35 4.29-1.42 11.09-7.36 14.84-11z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#82ceff",
    d: "m194.61 163.33 2.61-10.55 5.16-7.44a1.02 1.02 0 0 1 .79-.43l5.91-.21a.43.42 16 0 1 .37.66l-9.82 14.4a.66.65 45.6 0 0 0 .75l9.69 14.26q.5.73-.38.73h-5.65q-.51 0-.79-.43l-7.89-11.74z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#82ceff",
    d: "M215.47 144.83q2.2-.64 4.82.11.7.19.28.78l-9.56 13.42a1.7 1.69-44.9 0 0-.01 1.96l9.63 13.75q.45.65-.34.65h-5.76q-.62 0-.98-.52l-9.82-14.19a1.18 1.16-45.3 0 1 0-1.33q4.19-5.95 8-11.42 1.85-2.66 3.74-3.21z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#5a98d7",
    d: "M230.97 175.5h-5.1a1.14 1.13 72.7 0 1-.94-.5l-9.78-14.35a.81.8-45.5 0 1 0-.91l9.66-14.22a1.76 1.75-72.5 0 1 1.47-.77l5.38.01a.46.46 0 0 1 .37.73l-9.89 14.16a.84.84 0 0 0-.01.95l9.71 14.08q.33.47-.05.91-.28.32-.58.01a.34.34 0 0 0-.24-.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5827f",
    d: "M109.52 147.82q2.24.29 2.63 1.65a.72.72 0 0 0 .63.51q2.68.22 4.76-.51 1.69 4.53 1.85 9.13-3.43 5.77-10.92 4.52l-7.2-1.19q-1.88-1.55-4.37-1.35-1.27-5.09 1.03-9.68 1.68.47 2.89-.71l8.7-2.37z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#82ceff",
    d: "M96.9 160.58q2.49-.2 4.37 1.35c.16 4.45 1.3 14.06 6.3 15.86q-.99 15.25-2.04 21.97-4.89 31.01-7.78 62.3l-9.66-.28-3.36-.44a.63.63 0 0 1-.55-.6c-.25-10.58-.75-21.7.32-32.15.79-7.75 2.52-15.09 2.3-22.93a.59.59 0 0 0-1.17-.11q-6.38 27.6-9.84 55.73-.06.49-.49.72-.95.51-2.51.43l-7.49-.16-2.28-.89q-.43-.16-.42-.63.86-21.26 3.89-42.28c1.73-11.99.95-24.4 1.5-36.57 15.84-.19 23.36-4.25 23.02-21.41q-.01-.5.49-.45l5.4.54zm-10.72 43.64 1.83.45a.25.25 0 0 0 .3-.18l.02-.08a25.43.84-76.1 0 0 5.29-24.89l-.68-.17a25.43.84-76.1 0 0-6.92 24.49l-.02.07a.25.25 0 0 0 .18.31z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe0056",
    d: "m101.27 161.93 7.2 1.19-.9 14.67c-5-1.8-6.14-11.41-6.3-15.86z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d5da9",
    d: "M147.8 167.45q16.69 5.08 34.41 1.23a.42.42 0 0 1 .5.51q-.8 3.23.24 5.4-1.85 3.27-2.28 6.62c-.22 1.79.43 3.8.34 5.91-4.65 1.2-4.76 4.4-5.52 8.25q-.1.55-.66.54l-6.49-.1-2.22-14.01q-.05-.31-.11 0-1.42 7.68.79 14.51-1.91.88-2.31 2.94-1.33 6.88-4.16 24.15-.08.5.23.89 2.54 3.15 6.01 5.05 1.79.81 3.74.67 1.02 16.17-.6 32.29-.1 1-2.33.71l-7.34.13q-1.56.18-1.66-.82-2.88-29.56-7.9-58.82-2.19-12.79-2.68-36.05z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#9eddec",
    d: "M51.16 190.59c4.99 1.33 9.53 4.14 8.95 9.91-.46 4.57-3.97 7.37-8.45 7.59q-.66.03-.66.69v1.79a1.5 1.5 0 0 1-2.95.41q-.21-.78-.02-1.8a.75.75 0 0 0-.64-.89q-6.75-.85-9.22-7.07a1.57 1.57 0 0 1 1.61-2.15l3.13.31a1.02 1.01-12.2 0 1 .78.5q1.23 2.16 3.58 2.9a.56.56 0 0 0 .73-.54v-6.53a.73.71 6 0 0-.58-.7c-11.72-2.33-12.12-15.5-.06-17.86q.42-.08.52-.5l.76-3.14a.62.62 0 0 1 .98-.34q1.6 1.23 1.07 3.33a.62.61 11.4 0 0 .51.76q6.12.84 8.67 6.3 1.31 2.79-1.77 2.71l-2.79-.07q-.48-.02-.7-.45-.91-1.77-2.6-2.76a.63.63 0 0 0-.95.51l-.35 6.47a.6.6 0 0 0 .45.62zm-3.22-1.96.14-5.16a.63.63 0 0 0-.62-.64l-.23-.01a3.14 3.12 1.5 0 0-3.22 3.04v.18a3.14 3.12 1.5 0 0 3.06 3.2h.23a.63.63 0 0 0 .64-.61zm3.08 8.2.02 5.54a.29.29 0 0 0 .3.29h.2a2.99 2.98-.3 0 0 2.97-3v-.16a2.99 2.98-.3 0 0-3.01-2.96h-.2a.29.29 0 0 0-.28.29z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5827f",
    d: "m182.95 174.59 8.54.73 1.36 12.16-2.18 2.53q-1.03.82-1.18 1.61l-4.34 1.8a1.05 1.03 48.9 0 1-.95-.07l-3.64-2.21q.78-1.22 2.08-1.33a.52.52 0 0 0 .47-.57l-.16-1.83q-.04-.49-.52-.44l-1.42.15c.09-2.11-.56-4.12-.34-5.91q.43-3.35 2.28-6.62z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#5a98d7",
    d: "M86.18 204.22a.25.25 0 0 1-.18-.31l.02-.07a25.43.84-76.1 0 1 6.92-24.49l.68.17a25.43.84-76.1 0 1-5.29 24.89l-.02.08a.25.25 0 0 1-.3.18l-1.83-.45z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b4274",
    d: "m168.34 195.81-1.54.5q-2.21-6.83-.79-14.51.06-.31.11 0l2.22 14.01z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.94 188.63a.63.63 0 0 1-.64.61h-.23a3.14 3.12 1.5 0 1-3.06-3.2v-.18a3.14 3.12 1.5 0 1 3.22-3.04l.23.01a.63.63 0 0 1 .62.64l-.14 5.16z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b2d53",
    d: "m181.01 187.12 1.42-.15q.48-.05.52.44l.16 1.83a.52.52 0 0 1-.47.57q-1.3.11-2.08 1.33-1.73 1.04-1.59 4.02.02.52.55.53l9.69.15 4.75.12q.49.02.46-.48-.21-3.9-3.75-5.47l2.18-2.53q4.2 2.79 4.67 7.96.04.47.51.45l9.28-.33-13.8 16.72q-2.79-2.74-9.65-1.17-2.43.06-4.58-2.42-4.57-5.28-9.7-10.21-1.17-1.12-2.1.21c-.08.12.11 1.75.1 2.08q-.73 14.17-1.01 28.57-3.47-1.9-6.01-5.05-.31-.39-.23-.89 2.83-17.27 4.16-24.15.4-2.06 2.31-2.94l1.54-.5 6.49.1q.56.01.66-.54c.76-3.85.87-7.05 5.52-8.25z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M190.67 190.01q3.54 1.57 3.75 5.47.03.5-.46.48l-4.75-.12.28-4.22q.15-.79 1.18-1.61z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d5da9",
    d: "m180.56 191.14 3.64 2.21a1.05 1.03 48.9 0 0 .95.07l4.34-1.8-.28 4.22-9.69-.15q-.53-.01-.55-.53-.14-2.98 1.59-4.02z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.02 196.83a.29.29 0 0 1 .28-.29h.2a2.99 2.98-.3 0 1 3.01 2.96v.16a2.99 2.98-.3 0 1-2.97 3h-.2a.29.29 0 0 1-.3-.29l-.02-5.54z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b4274",
    d: "M207.31 195.56q2.57 17.1 2.76 30.19.04 3.17-3.31 3.31l-14.69.61-16.69.21-5.07.13q-1.95.14-3.74-.67.28-14.4 1.01-28.57c.01-.33-.18-1.96-.1-2.08q.93-1.33 2.1-.21 5.13 4.93 9.7 10.21 2.15 2.48 4.58 2.42-.83 2.62-.21 5.27a.81.81 0 0 0 .79.62l7.29-.01a1.04 1.04 0 0 0 1.03-1.22q-.28-1.67.75-3.49l13.8-16.72z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d5da9",
    d: "M193.51 212.28q-1.03 1.82-.75 3.49a1.04 1.04 0 0 1-1.03 1.22l-7.29.01a.81.81 0 0 1-.79-.62q-.62-2.65.21-5.27 6.86-1.57 9.65 1.17zM192.07 229.67c.24 3.71 1.62 32.53-.07 33.38l-8.75.43-.9-.33q-.51-.18-.61-.72l-6.36-32.55 16.69-.21z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5827f",
    d: "M97.75 262.06q-1.12 3.27-.19 6.24c-3.57 3.55-6.08 1.3-9.94 2.15l.47-8.67 9.66.28zM72.79 262.43l-.82 6.75q-3.09-2.25-7.77-1.06l1.1-5.85 7.49.16zM167.38 263.01l.87 4.04-4.05 2.02q-.49.25-.85-.16l-3.98-4.59q.54-.38.67-1.18l7.34-.13zM192 263.05l.06 2.23q-4.99-.9-8.26 1.65l-.55-3.45 8.75-.43z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#82ceff",
    d: "m159.37 264.32 3.98 4.59q.36.41.85.16l4.05-2.02q1.85 5.25 2.07 10.37-15.6 1.76-31.11-.64c7.62-3.89 12.71-6.19 20.16-12.46zM192.06 265.28l7.57 12.27-15.57.25-.26-10.87q3.27-2.55 8.26-1.65z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d5da9",
    d: "m71.97 269.18.01 8.98q-6.68.97-13.29-.2l5.51-9.84q4.68-1.19 7.77 1.06zM117.48 276.57l-.54 1.26q-.17.39-.59.39l-30.98.01 2.25-7.78c3.86-.85 6.37 1.4 9.94-2.15q3.78 1.48 7.63 3.61c3.92 2.16 8.24 2.69 12.29 4.66zM139.21 276.78q15.51 2.4 31.11.64 1.41 2.09.71 3.78-.19.47-.7.48c-10.11.19-23.58 1.39-31.39-1.47q-.46-.17-.62-.64-.76-2.26.89-2.79z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b4274",
    d: "M117.48 276.57q2.31 2.32 1.25 4.4-.27.53-.87.53H85.74a.72.72 0 0 1-.7-.56q-.25-1.04.33-2.71l30.98-.01q.42 0 .59-.39l.54-1.26z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d5da9",
    d: "M199.63 277.55q1.05 1.54.8 2.92a1.56 1.55-84.9 0 1-1.53 1.28h-14.13q-.57 0-.69-.55-.36-1.55-.02-3.4l15.57-.25z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b4274",
    d: "M58.69 277.96q6.61 1.17 13.29.2l-.02 3.26q-.01.57-.58.57-5.36.02-10.83.05c-3.19.01-3.16-1.74-1.86-4.08z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraders);
export default __webpack_public_path__ + "static/media/traders.4ed32955d85f5ac00d1a23906b7beeb8.svg";
export { ForwardRef as ReactComponent };